
 <mat-drawer-container autosize >
        <!-------------------------->
        <!-- Right hand drawer    -->
        <!-- Open state           -->
        <!-------------------------->

        <mat-drawer position="end" opened="true" class="mat-elevation-z2"
                    [ngClass]="{'hide-drawer': showDrawer === false}"
                    style="border: .5px solid #e1e1e1; animation: gen_css_kf_24 400ms linear 0ms 1
                    normal forwards
                    running;height:100%" #drawer
                    (openedChange)="displayDrawerData()"
                    mode="side" disableClose="true">
            <div style="max-width: 480px; padding: 0px;" >
                <table [hidden]="!propContainerState" style="min-width: 420px;">
                    <TR style="vertical-align: center;">
                     <TD align="left" style="width: 35px; padding: 0;">
                            <button id="requests-toggle-drawer-close-btn" mat-icon-button
                                    (click)="onPropertiesToggle()">
                                <mat-icon>arrow_right</mat-icon>
                            </button>
                        </TD>
                        <TD width="100%" style="text-align: left;">
                            <b>Notes / Properties</b>
                        </TD>
                        <TD width="35px"></TD>
                    </TR>
                </table>

                <div [hidden]="!propContainerState"
                     class="prop-menu-container" style="scale: 98%; width:420px;min-width: 410px !important;">
                    <mat-tab-group class="prop-tab-group" (selectedTabChange)="doDrawerTabChange($event)"
                                   style="height: 100%"  >

                        <mat-tab label="Past Assistance" *ngIf="showPastAssistanceTab">
                            <app-pastassistance #pastAssistance [from]="'cases'">
                            </app-pastassistance>
                        </mat-tab>

                        <mat-tab label="Notes" *ngIf="showNotesTab">
                            <app-notes style="border-top: .5px solid #e1e1e1" #notes
                                [readOnly]="selectedRecord?.caseStatus !== 'Open'"
                                [primaryAgencyFlag]="primaryAgencyFlag"
                                [callingComponent]="'Cases'"
                                [from]="'cases'">
                            </app-notes>
                        </mat-tab>
                        <mat-tab label="Email" *ngIf="showEmailsTab">
                            <app-mailmessages #mailMessages
                                 [readOnly]="selectedRecord?.caseStatus !== 'Open'"
                                 [selectedRequest]="selectedRecord"
                                 [caseId]="selectedCaseId"
                                 [from]="'cases'"
                                 [tableName]="'Cases'">
                            </app-mailmessages>
                        </mat-tab>
                    </mat-tab-group>
                </div>
            </div>
            <div>

            <!----------------------->
            <!-- Right hand Drawer -->
            <!-- retracted state ---->
            <!----------------------->

            <div [hidden]="propContainerState" width="100%">
                <button id="requests-toggle-drawer-open-btn" mat-icon-button (click)="onPropertiesToggle()">
                    <mat-icon>arrow_left</mat-icon>
                </button>
            </div>

            <div class="rotate-text" [hidden]="propContainerState">
                Notes / Properties
            </div>

        </div>
        </mat-drawer>
        <div class="main-client-area">

            <!------------------------------->
            <!--  Detail panel             -->
            <!------------------------------->
            <div id="requests-details-panel" class="mat-elevation-z2"
                 style="margin-bottom: 0px;overflow: hidden;">
                  <div class="container">
				    <div class="right-container">
				      <table class="info-table">
				        <tr>
				          <td rowspan="2" style="width: 78px; border: .5px solid #E1E1E1;">
				          	<div *ngIf="showCaseAvatar" class="avatar-image" #avatar id="avatar" (click)="showCaseAvatarPreview()"></div>
				          </td>
				          <td><label style="width:110px;display: inline-table">&nbsp;Case:</label> <span style="font-weight: bold;">{{strCaseNumber}}</span></td>
				          <td><label style="width:110px;display: inline-table">Case Status:</label> <span style="font-weight: bold;">{{strCaseStatus}}</span></td>
				          <td><label style="width:150px;display: inline-table">Number of Days Open: </label><span
                                  style="font-weight: bold; width: 50px;height:25px;text-align:center; padding-top:4px;
                                  vertical-align:middle; display: inline-block;"
                            [ngStyle]="{'background-color': getBackgroundColor(selectedRecord) }">{{strDaysOpen}}</span></td>
				        </tr>
				        <tr>
				          <td><label style="width:110px;display: inline-table">&nbsp;Applicant: </label><span style="font-weight: bold;">{{strApplicant}}</span></td>
				          <td><label style="width:110px;display: inline-table">Date Closed:</label><span style="font-weight: bold;">{{selectedRecord?.dateClosed | date:'mediumDate':'EST'}}</span></td>
				          <td><label style="width:110px;display: inline-table"></label><span style="font-weight: bold; width: 40px;text-align:center;display:  inline-block;"></span></td>
				        </tr>
				      </table>
				    </div>
				  </div>

                <mat-tab-group animationDuration="0ms" (selectedTabChange)="doTabChange($event)" style="min-width:1224px;">

                    <mat-tab label="Case" [disabled]="isEditing" class="dwform">
                        <div class="sub-tab-container-class detail-tab-additional" >
                        	<app-case-details #casedetails 
                                (changeStatusEvent)="doChangeStatus($event)" [from]="'cases'"
                                (editEvent)="isEditing=$event;this.editEvent.emit($event)"></app-case-details>
                        </div>
                    </mat-tab>

                    <mat-tab label="Members" *ngIf="showMembersTab" [disabled]="isEditing" style="background-color: #e1e1e1;">
                        <div class="sub-tab-container-class detail-tab-additional" >
                        	<app-members #members [from]="'cases'" (membersChanged)="doReloadMembers()"></app-members>
                        </div>
                    </mat-tab>
                     <mat-tab label="Documents" *ngIf="showDocumentsTab" [disabled]="isEditing" style="background-color: #e1e1e1;">
                        <div class="sub-tab-container-class detail-tab-additional">
                        	<app-case-documents [from]="'cases'" #casedocuments></app-case-documents>
                        </div>
                    </mat-tab>
                 	  <mat-tab label="Case Requests" *ngIf="showCaseRequestsTab" [disabled]="isEditing" class="dwform">
                        <div class="sub-tab-container-class detail-tab-additional">
                        	<app-case-requests-list #requests
                                      [caseRecord]="selectedRecord"
                                      [from]="'cases'"></app-case-requests-list>
                        </div>
                    </mat-tab>
                     <mat-tab label="Qualifications" *ngIf="showQualificationsTab" [disabled]="isEditing" style="background-color: #e1e1e1;">
                        <div class="sub-tab-container-class detail-tab-additional">
                        	<app-qualification-responses #qualifications
                                   [calledFrom]="'cases'"
                                   [caseRecord]="selectedRecord"
								  (editEvent)="isEditing=$event;this.editEvent.emit($event)">
                        	</app-qualification-responses>
                        </div>
                    </mat-tab>
                    <mat-tab label="Activity" *ngIf="showActivityTab" [disabled]="isEditing" style="background-color: #e1e1e1;">
                        <div class="sub-tab-container-class detail-tab-additional">
                            <transaction-history #history [from]="'cases'" [enforceSecurity]="true">
                            </transaction-history>
                        </div>
                    </mat-tab>
                </mat-tab-group>
            </div>
        </div>
    </mat-drawer-container>

    <p-dialog header="Press Escape to close" [focusOnShow]="false" [showHeader]="true"
          [(visible)]="visiblePreviewCaseAvatarDialog"
		  [modal]="false"
          appendTo="body"
          [minY]="35" [resizable]="true" [closable]="true" >
	<div class="canvas-area">
		<app-caseavatarpreview #previewCaseAvatar (cancelClicked)="hideCaseAvatarPreview()"></app-caseavatarpreview>
	</div>
</p-dialog>
